import { IFieldTemplateConfiguration } from 'src/app/core/template-configuration/template-configuration-base';
import { Template } from 'src/app/core/template/template';

export class SlideTemplate {
  public template: Template;
  public fields: IFieldTemplateConfiguration[];
}
